import React from 'react';

import {Helmet} from 'views/module';

import AllTasksScene from 'views/scenes/tasks/all_tasks/AllTasks';

const AllTasks = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: All Tasks</title>
      </Helmet>
      <AllTasksScene />
    </>
  );
};

export default AllTasks;
